import { ChangeDetectorRef, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HeadingSectionType01Component } from "../../heading-section/heading_section-type01/heading_section-type01.component";
import { Router, RouterLink } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { FuseCardComponent } from '@fuse/components/card';

@Component({
  selector: 'app-services-type02',
  standalone: true,
  imports: [MatIconModule, HeadingSectionType01Component, FuseCardComponent, RouterLink],
  templateUrl: './services-type02.component.html',
  styleUrl: './services-type02.component.scss'
})
export class ServicesType02Component {

  public view: any = {

  };
  constructor(private _cd: ChangeDetectorRef, private _router: Router, private _tfmService : TFMService) {  }

  ngOnInit(): void {
    this._tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
      this._tfmService.log(this.view);

    });
  }
}
